import React, { Component } from "react";
import Form from "react-jsonschema-form";
import {Button ,Glyphicon} from "react-bootstrap";
import ReactJson from 'react-json-view'



const log = (type) => console.log.bind(console, type);



//This can be a file that the server references :)

function icon_from_name(name_string){
	var name=name_string.toLowerCase()
  var default_input_icon='fa-exclamation'
	//Default icon
	var r=default_input_icon
	//first item is the icon you want followed by a list of words to associate to that icon
	var iconlist=[
      ['fa-close','disable','No input'],
			['fa-bed','bed','bedroom','epilepsy','enuresis','bed wet','enuresis sensor'],
			['fa-volume-up','audio','mic','microphone','sound','sound detector','noise detector','shout detector'],
			['fa-paw','motion','motion detector','PIR','movement','movement sensor','motion sensor'],
			['fa-tint','flood'],
			['fa-sign-out','door'],
			['fa-windows','window','windows'],
			['fa-square','floor'],
			['fa-bell','buzzer','beep','bell','beep test', 'buzz'],
			['fa-lightbulb-o','lamp on','light on','lights on','lamp on','light off','lamp off','lights off'],
			['fa-phone','make call','call'],
			['fa-mobile','sms','text','send text','send sms'],
			['fa-envelope-o','email','mail','send email','send mail'],
			['fa-archive','log'],
			['fa-times','no action']
		]

	//convert everything to lowercase
	iconlist=JSON.parse(JSON.stringify(iconlist).toLowerCase())

	iconlist.forEach(function(e){
		if(e.indexOf(name)!==-1){
			r=e[0];
		}
	});
	return r;
}


function Dect(props){
//  console.log("Dectinfo")
console.log(props)

let tamperStr=""
let tamper=props.data.tamper
console.log("tamper:"+tamper)
if(tamper==2)
  tamperStr="CASE OPEN"

let unpair={
  cmd:"DECT",
  type:"DELETE",
  ipiu:props.data.id
}

let temprate1={
  cmd:"DECT",
  type:"TEMP_INTERVAL",
  INTERVAL:6,
  ipiu:props.data.id
}

let temprate7={
  cmd:"DECT",
  type:"TEMP_INTERVAL",
  INTERVAL:42,
  ipiu:props.data.id
}

let temprate14={
  cmd:"DECT",
  type:"TEMP_INTERVAL",
  INTERVAL:84,
  ipiu:props.data.id
}

let temprate28={
  cmd:"DECT",
  type:"TEMP_INTERVAL",
  INTERVAL:126,
  ipiu:props.data.id
}



let PIR1={
  cmd:"DECT",
  type:"ATTRIB",
  unit:1,
  ipiu:props.data.id,
  attrib_id:0x7F11,
  attrib_slot:2,
  payload:[0x01]

}

let PIR2={
  cmd:"DECT",
  type:"ATTRIB",
  unit:1,
  ipiu:props.data.id,
  attrib_id:0x7F11,
  attrib_slot:2,
  payload:[0x03]

}

let PIR3={
  cmd:"DECT",
  type:"ATTRIB",
  unit:1,
  ipiu:props.data.id,
  attrib_id:0x7F11,
  attrib_slot:2,
  payload:[0x06]
}

let PIR4={
  cmd:"DECT",
  type:"ATTRIB",
  unit:1,
  ipiu:props.data.id,
  attrib_id:0x7F11,
  attrib_slot:2,
  payload:[0x0C]
}

let PIR5={
  cmd:"DECT",
  type:"ATTRIB",
  unit:1,
  ipiu:props.data.id,
  attrib_id:0x7F11,
  attrib_slot:1,
  payload:[0x00]
}
let PIR6={
  cmd:"DECT",
  type:"ATTRIB",
  unit:1,
  ipiu:props.data.id,
  attrib_id:0x7F11,
  attrib_slot:1,
  payload:[0x01]
}


let dect_buttons=""
if (props.data.type==512){
  dect_buttons=(<span>
  <span>
  &nbsp;Update Interval:&nbsp;</span>
  <Button onClick={()=>props.callback(temprate1)}  title={props.data.id}>1 min</Button>
  <Button onClick={()=>props.callback(temprate7)}  title={props.data.id}>7 mins</Button>
  <Button onClick={()=>props.callback(temprate14)} title={props.data.id}>14 mins</Button>
  <Button onClick={()=>props.callback(temprate28)} title={props.data.id}>28 mins</Button>
  </span>)
}

if (props.data.type==641){
  //This is a a wireless dect SENSOR

  //Show the filter options
  dect_buttons=(<span>Alter settings</span>)




}

if (props.data.type==515){
  //This is a a wireless dect SENSOR

  //Show the filter options
  dect_buttons=(<span>
    <span>
    &nbsp;Trigger Interval:&nbsp;</span>
    <Button onClick={()=>props.callback(PIR1)}  title={props.data.id}>10 Seconds</Button>
    <Button onClick={()=>props.callback(PIR2)}  title={props.data.id}>30 Seconds</Button>
    <Button onClick={()=>props.callback(PIR3)} title={props.data.id}>1 min</Button>
    <Button onClick={()=>props.callback(PIR4)} title={props.data.id}>2 min</Button>&nbsp;<b>Mode</b>
    <Button onClick={()=>props.callback(PIR5)} title="Subsequent motion keeps sensor active">Retrigger</Button>
    <Button onClick={()=>props.callback(PIR6)} title="Sensor resets after trigger interval">Normal</Button>
    </span>)




}



return(<div>
      <Button onClick={()=>props.callback(unpair)} title={props.data.id}>Unpair Sensor </Button>
      {dect_buttons}
      </div>)
}



function selectedClass(d){try{if (d.selected===true){return ("selected")}else{return ("")}}catch(err){return ("")}}

function InputChoices(props){
  return (<div className="col textCenter"><div className={'inputCircle '+selectedClass(props.data)} onClick={()=>props.parent.inputSelected(props.data)}>
        <i className={"fa "+icon_from_name(props.data.name)+" fa-2x"}></i></div><p>{props.data.name}</p></div>)
}




function DisplayFilterOptions(props){

        let inoptions=props.inputOptions


        return (<div className="flex-grid">{inoptions.map(l=>
            <InputChoices key={l.index} data={l} parent={props.parent}></InputChoices>
          )}</div>)


}


export default class InputEdit extends Component {
    constructor(props) {
      super(props);
      this.state = {
        data:props.data,
        advancedEdit:false,
        nameEdit:false,
        inputName:props.data.name,
        inputIndex:props.inputIndex,
        inputOptions:[],
        inputChangeIndex:-1,

        changeInputSettings:false


      };

      fetch("/static/filters.json", {cache: 'no-cache'}).then(response => {
    //console.log(response);
    return response.json();
    }).then(data => {
    // Work with JSON data here
    //console.log("FETCH COMPLETE?")
    //console.log(data);
    this.setState({"inputOptions":data})
    }).catch(err => {
    // Do something for an error here
    console.log("Error Reading data " + err);
    });




    }
    componentDidMount() {
      console.log("Input Edit")
      console.log(this.props.data)
      this.setState({data:this.props.data})
    }


    startFilterSelect=()=>{


      let temp=this.state.inputOptions
      for(var i=0;i<temp.length;i++){ //dirty
            temp[i].selected=false;
      }
      this.setState({inputChangeIndex:-1})
      this.setState({"changeInputSettings":true})


    }


    inputSelected(d){
      console.log("Input Selected?")
      console.log(d)

      var temp=this.state.inputOptions
      for(var i=0;i<temp.length;i++){ //dirty
        temp[i].selected=false;
      }
      temp[d.index].selected=true
      this.setState({inputChangeIndex:d.index})
      //the rest need to be unselected :(
      this.setState({inputOptions:temp})

    }

    test=()=>{
      console.log("Running Test")
    }

    printDebug=()=>{
    }

    submit =(d)=>{
          console.log(JSON.stringify(d.formData))
    }

    onChange=(d)=>{
      this.setState({data:d.formData})
    }
    cancel=()=>{
      console.log("Cancel Action")
      this.props.callback("cancel",this.state.data)
    }


    cancelInput=()=>{

      this.setState({"changeInputSettings":false})

    }


    saveInput(){
        console.log("Save Input")
        console.log(this.props.data)
        let filtersAllowed=false
        //Its a physical input
        if(this.props.data.id<3){
              filtersAllowed=true
              console.log("Wired Input")
        }
        if("type" in this.props.data){
            //Its a dect device
            //its an altiom input module
            if(this.props.data.type==641){
                filtersAllowed=true
            }
        }

        if(this.state.inputChangeIndex!==-1 && filtersAllowed==true){
          //We have a change of input
          let mergedobj={}
          if(this.state.id<3){

                 mergedobj=this.state.inputOptions[this.state.inputChangeIndex]

                }else{

                 mergedobj={...this.state.data,...this.state.inputOptions[this.state.inputChangeIndex]}
                }
                console.log(mergedobj)
                this.props.callback({"cmd":"input","type":"update","input_index":this.state.inputIndex,"data":mergedobj})
                //this.post({"cmd":"input","type":"update","input_index":this.state.inputIndex,"data":mergedobj})
                this.setState({"changeInputSettings":false})
        }
    }
    editInputName=()=>{
      //Copy name into the data
      this.setState({data:this.props.data})
      this.setState({nameEdit:true})
    }
    inputNameChange=(event)=>{
      console.log(event)
      let temp=this.state.data
      temp.name=event.target.value
      this.setState({data: temp});
    }
    inputNameActiveChange=(event)=>{
      console.log(event)
      let temp=this.state.data
      temp.name_active=event.target.value
      this.setState({data: temp});
    }
    inputNameInActiveChange=(event)=>{
      console.log(event)
      let temp=this.state.data
      temp.name_inactive=event.target.value
      this.setState({data: temp});
    }

    inputsTypeChange=(event)=>{
      console.log(event)
      let temp=this.state.data
      temp.stype=event.target.value
      this.setState({data: temp});
    }

    saveInputName=()=>{
      let temp=this.state.data
      if("stype" in temp){ //remove stype if its not set
        if(temp.stype.length==0){
          delete temp.stype
        }
        else {
          temp.stype=temp.stype.toLowerCase()
        }

      }

      this.setState({nameEdit:false})
      let updatinput={"cmd":"input","type":"update","input_index":this.state.inputIndex,"data":this.state.data}
      this.props.callback(updatinput)
    }

    render(){
      if(this.props.data.disabled==true){
        return (<div><h3>Unused wired input Port:({this.props.data.id+1})<Button onClick={()=>this.startFilterSelect()}>Alter settings</Button></h3>


        {this.state.changeInputSettings ? (<div>
            <DisplayFilterOptions inputOptions={this.state.inputOptions} parent={this}></DisplayFilterOptions>
            <center>
              <Button onClick={()=>this.saveInput()}>Save</Button>
              <Button onClick={()=>this.cancelInput()}>Cancel</Button>
              </center>
          </div>):("")}
        </div>


      )

      }
      return (<div key={this.props.data.id}>
          <hr/>
              {this.state.nameEdit ? (
                <div>
                  <input className={"tamper"+this.props.data.tamper} value={this.state.data.name}           onChange={this.inputNameChange}></input>
                  <input className={"tamper"+this.props.data.tamper} value={this.state.data.name_active}    onChange={this.inputNameActiveChange}></input>
                  <input className={"tamper"+this.props.data.tamper} value={this.state.data.name_inactive}  onChange={this.inputNameInActiveChange}></input>
                  <hr/>
                  <p>Sensor Type</p>
                  <input className={"tamper"+this.props.data.tamper} value={this.state.data.stype}  onChange={this.inputsTypeChange}></input>
                  <Button onClick={()=>this.saveInputName()}>Done</Button>
                  <br/>
                </div>
          ):(
            <div>
              <h3 className={"tamper"+this.props.data.tamper}>{this.props.data.name}&nbsp;<Glyphicon onClick={()=>this.editInputName()} title="Edit name" className="iconBut" glyph="pencil" /></h3>
              {this.state.data.id<3?(

                <div>
                <Button onClick={()=>this.startFilterSelect()}>Alter settings</Button>
                {this.state.changeInputSettings ? (<div>
                    <DisplayFilterOptions inputOptions={this.state.inputOptions} parent={this}></DisplayFilterOptions>
                    <center>
                      <Button onClick={()=>this.saveInput()}>Save</Button>
                      <Button onClick={()=>this.cancelInput()}>Cancel</Button>
                      </center>
                  </div>):("")}
                </div>
              ):(<div>

                {this.props.data.type==641 ? (<div>
                  <Button onClick={()=>this.startFilterSelect()}>Alter settings</Button>
                {this.state.changeInputSettings ? (<div>

                    <DisplayFilterOptions inputOptions={this.state.inputOptions} parent={this}></DisplayFilterOptions>
                    <center>
                      <Button onClick={()=>this.saveInput()}>Save</Button>
                      <Button onClick={()=>this.cancelInput()}>Cancel</Button>
                      </center>
                  </div>):<div>{this.props.data.id}</div>}
                </div>):(<div>{this.props.data.id}</div>)}





                </div>)
              }


          </div>)
          }
              {this.props.data.src=="dect"? (
                <Dect key={this.props.data.id} callback={this.props.callback} data={this.props.data}></Dect>):(<span></span>)}
          </div>
        )







    }

}



// WEBPACK FOOTER //
// ./src/programmerComponents/InputEdit.js